import { ErrorName } from 'errors/Error.utils';
import { ErrorWithUi } from 'errors/ErrorWithUi';

export class RequestCancelledError extends ErrorWithUi {
  readonly name = ErrorName.RequestCancelled;
}
